import { render } from "./CodeText.vue?vue&type=template&id=4f29b8dc&ts=true"
import script from "./CodeText.vue?vue&type=script&lang=ts"
export * from "./CodeText.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__